import {
    AtualizarUsuarioInterface,
    IListaUsuariosTransferencias,
    UsuarioInterface,
} from "../../../Interfaces/Geral/GestaoUsuarios/UsuariosInterface";
import { IUserDashboard } from "../../../Interfaces/Users/UsersInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarUsuariosService() {
    return Service(
        Axios.get<Array<UsuarioInterface>>(`/home/users/listarusuario`)
    );
}

export async function ListarUsuariosGrupoService(grupo: boolean) {
    return Service(
        Axios.get<Array<UsuarioInterface>>(
            `/home/users/listarusuario?grupo=${grupo}`
        )
    );
}

export async function ListarUsuariosMesmoProdutoService() {
    return Service(
        Axios.get<Array<UsuarioInterface>>(
            `/home/listarusuariosmesmoproduto/listausuariosmesmoproduto`
        )
    );
}

export async function GetUsuarioInfoService(idUsuario: number) {
    return Service(
        Axios.get<UsuarioInterface>(
            `/home/users/getusuarioid?idUsuario=${idUsuario}`
        )
    );
}

export async function AtualizarUsuarioService(
    requestBody: AtualizarUsuarioInterface,
    idUsuarioCopia?: number
) {
    return Service(
        Axios.put(
            `/home/users/atualizarusuario?idUsuarioCopia=${idUsuarioCopia}`,
            requestBody
        )
    );
}

export async function DeletarUsuarioService(idUsuario: number) {
    return Service(
        Axios.delete(`/home/users/deletarusuario?idUsuario=${idUsuario}`)
    );
}
export async function ListarUsuariosTransferenciaService(
    requestBody: IListaUsuariosTransferencias
) {
    return Service(
        Axios.post<Array<IUserDashboard>>(
            `/home/users/listarusuariostransferencia`,
            requestBody
        )
    );
}
